<template>
<div v-if="visible" id="cardContainer" class="modal is-active">
    <div class="modal-background"/>

    <div class="modal-card">
            <div class="modal-card-head">
                <p class="modal-card-title"></p>
                <button class="delete" aria-label="close" @click="visible=false"></button>
            </div>
        <div id="cardBody" class="modal-card-body">
            <div class="content">
                            <h1 class="title">10 Candles</h1>
                <h3 class="subtitle"><em>These things are true. The world is dark. And we are alive.</em></h3>
            <p>
                Welcome to the 10 candles unofficial web tool. This tool is intended to be a utility to run 10 Candles tragic horror RPG online. It is not associated with Cavalry games and is 100% fanmade.
                This tool offers candle management, dice rollers (for us and "them"), character management, candle management, and phase tracking for truths and the last stand.
            </p>
            <p>
                While this tool tries its best, it cannot replicate the feel and atmosphere of in-person 10 candles. That must be experieced if you are a fan of this amazing
                system. But what it does offer is accessible access to play, and create engaging stories and moments remotely.
            </p>
            <p>
                If you do not know how to play 10 candles, you can find the official website <a href="https://cavalrygames.com/ten-candles">here.</a>
            </p>
            <p>
                For now though, I hope you enjoy! If you want to support me, or host the game yourself, you cna checkout my GitHub page  <a href="https://github.com/Singhmansingh">here.</a>
            </p>
                <p class="content block">
                    Controls:
                        <ol class='controls'>
                            <li>1 - 9 - Out a candle </li>
                            <li>0 - Out the final candle </li>
                            <li>` - Add a character </li>
                            <li>Space - progress truths </li>
                        </ol>
                   
                </p>
                 <p class="content block">
                    Notes:
                        <ol class='controls'>
                            <li>This tool does not do character creation, just lets you store the results</li>
                            <li>Hold "Roll" button to continously roll the dice, release when ready.</li>
                            <li>Changes can be made while a game is running.</li>
                        </ol>
                   
                </p>
            </div>

        </div>
        <div class="modal-card-foot"/>
    </div>
</div>    
</template>

<script>
export default {
    name:"WelcomeCard",
    data(){
        return {
            visible:true
        }
    }
}
</script>

<style scoped>
    .modal-card-head,.modal-card-foot {
        background-color: rgb(18,18,18);
        border-bottom-width: 0px;
        border-top-width: 0px;
    }
    .modal-card-body {
        background-color: rgb(32,32,32);
        color:white;
        text-align: left;
        line-height: 1.75em;
        font-family: serif;
    }

    .title, .subtitle {
        color: white;
        text-align: center;
                font-family: "SansCulottes";

    }
    .subtitle {
        font-size: 1.25em;
    }



    .subtitle {
        opacity: 0.5;
    }

</style>